
export const img_src = new URL('../img/proxy-2.jpg', import.meta.url);

export function ProxyImg2() {
  return <img src={img_src} className="h-auto mb-8 self-center rounded-lg shadow-xl" />;
}

# Quick Demo

<ProxyImg2 />
